"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const notifi_axios_utils_1 = require("@notifi-network/notifi-axios-utils");
const DEPENDENCIES = [];
const MUTATION = `
mutation deleteAlert(
  $id: String!
) {
  deleteAlert(alertId: $id) {
    id
  }
}
`.trim();
const deleteAlertImpl = (0, notifi_axios_utils_1.makeRequest)((0, notifi_axios_utils_1.collectDependencies)(...DEPENDENCIES, MUTATION), 'deleteAlert');
exports.default = deleteAlertImpl;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGVsZXRlQWxlcnRJbXBsLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vbGliL211dGF0aW9ucy9kZWxldGVBbGVydEltcGwudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFBQSwyRUFHNEM7QUFNNUMsTUFBTSxZQUFZLEdBQWEsRUFBRSxDQUFDO0FBRWxDLE1BQU0sUUFBUSxHQUFHOzs7Ozs7OztDQVFoQixDQUFDLElBQUksRUFBRSxDQUFDO0FBRVQsTUFBTSxlQUFlLEdBQUcsSUFBQSxnQ0FBVyxFQUNqQyxJQUFBLHdDQUFtQixFQUFDLEdBQUcsWUFBWSxFQUFFLFFBQVEsQ0FBQyxFQUM5QyxhQUFhLENBQ2QsQ0FBQztBQUVGLGtCQUFlLGVBQWUsQ0FBQyJ9